import { Point } from '@/types';
import { isHorizontalLine, isVerticalLine } from './isLineType';
import { Line } from './types';

export function getPointOnLine(line: Line, scalar: number): Point {
  if (isHorizontalLine(line)) {
    return {
      x: scalar,
      y: line.y,
    };
  }

  if (isVerticalLine(line)) {
    return {
      x: line.x,
      y: scalar,
    };
  }

  return {
    x: scalar,
    y: line.m * scalar + line.b,
  };
}
